import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'





function GoverningBody() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(750);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [member, setMember] = useState([])
    const navigate = useNavigate()

    const memberCollectionRef = collection(db, "Governing Body");
    useEffect(() => {

        const getMember = async () => {
            const data = await getDocs(memberCollectionRef);
            setMember(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getMember()
    }, [])
    return (

        <>
       

            <div className='memberlist'>
                <br />


                <div className="album py-1">
                    <div className="container">
                        <h2 className='mt-0' style={{ color: "#079901" }}><b>Our Governing Body :</b></h2>
                    </div>
                </div>


                <div className="album py-2">

                    <div className="container">

                        <div className="row">

                            <div className="col-md-6">

                                <div className="card-body">
                                    <input type="text" className="form-control" placeholder="Search.. " name="location"
                                        onChange={(e) => {
                                            setsearchTerm(e.target.value);
                                        }}
                                    />
                                    <div className="d-flex justify-content-between align-items-center">




                                    </div>


                                </div>


                            </div>

                        </div>

                    </div>
                </div>
                <div className="album py-4">

                    <div className="container">

                        <div className="row">
                            {member.filter((val) => {
                                if (setsearchTerm === "") {
                                    return val;
                                } else if (
                                    val.name.toLowerCase().includes(searchTerm.toLowerCase())



                                ) {
                                    return val;
                                }
                            }).slice(pagination.start, pagination.end).map((chuapukurislamiccharitabletrust) => {
                                return (

                                    <div className="col-md-3">

                                        <div className="card mb-4 border-White box">
                                            <img className="card-img-top same-size-img" src={chuapukurislamiccharitabletrust.img} alt={chuapukurislamiccharitabletrust.name} />
                                            <div className="card-body">
                                                <h6>GOVERNING BODY </h6>
                                                <h5 style={{ color: "#005ED7" }} className="card-text mb-0"> <b>{chuapukurislamiccharitabletrust.name}</b></h5>
                                                <h5 style={{ color: "#032379" }} className="card-text mb-1"> <b>{chuapukurislamiccharitabletrust.position}</b></h5>

                                                <p>CHUAPUKUR ISLAMIC CHARITABLE TRUST</p>
                                                <p style={{ color: "#059128" }} className="card-text mb-0"> <b>{chuapukurislamiccharitabletrust.mob}</b></p>
                                                                                                <p style={{ color: "#059128" }} className="card-text"> <small>{chuapukurislamiccharitabletrust.email}</small></p>



                                            </div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

        </>

    );
}

export default GoverningBody;